import { createFileRoute } from '@tanstack/react-router'
import { StaffKesehatan } from '../../../../components/StaffKesehatan'

export const Route = createFileRoute('/desa/$slug/dashboard/kesehatan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffKesehatan desaId={desaId} />
  },
})
